import type { FC, HTMLAttributes, ReactNode } from "react";
import { cn } from "../utilities/cn";
import { panel, panelSm, panelInteractive } from "../utilities/styles";

export type PanelVariant = "default" | "compact" | "interactive";

export interface PanelProps extends HTMLAttributes<HTMLDivElement> {
  variant?: PanelVariant;
  children: ReactNode;
}

const variantClasses: Record<PanelVariant, string> = {
  default: panel,
  compact: panelSm,
  interactive: panelInteractive,
};

/**
 * Elevated surface primitive. Maps to semantic surface/border/shadow tokens.
 */
export const Panel: FC<PanelProps> = ({
  variant = "default",
  className,
  children,
  ...rest
}) => (
  <div className={cn(variantClasses[variant], className)} {...rest}>
    {children}
  </div>
);
